"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDecryptedTransferPayload = isDecryptedTransferPayload;
exports.isEncryptedTransferPayload = isEncryptedTransferPayload;
exports.isErrorDecryptingTransferPayload = isErrorDecryptingTransferPayload;
exports.isDeletedTransferPayload = isDeletedTransferPayload;
exports.isCorruptTransferPayload = isCorruptTransferPayload;
const domain_core_1 = require("@standardnotes/domain-core");
const utils_1 = require("@standardnotes/utils");
function isDecryptedTransferPayload(payload) {
    return (0, utils_1.isObject)(payload.content);
}
function isEncryptedTransferPayload(payload) {
    return 'content' in payload && (0, utils_1.isString)(payload.content);
}
function isErrorDecryptingTransferPayload(payload) {
    return isEncryptedTransferPayload(payload) && payload.errorDecrypting === true;
}
function isDeletedTransferPayload(payload) {
    return 'deleted' in payload && payload.deleted === true;
}
function isCorruptTransferPayload(payload) {
    const invalidDeletedState = payload.deleted === true && payload.content != undefined;
    const contenTypeOrError = domain_core_1.ContentType.create(payload.content_type);
    return payload.uuid == undefined || invalidDeletedState || contenTypeOrError.isFailed();
}
